<template>
  <div>
    counterpartiesClosed
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>